/**
 * @vuepress
 * ---
 * title: Customer Units
 * ---
 */

import Transformer from '../transformer'
import assetURL from '@/utils/assetURL'

/**
 * @class CustomerTransformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

class customerTransformer extends Transformer {
  /**
   * Transform fetched customer info
   *
   * @param customer The fetched customer/customers
   *
   * @returns {Object} The transformed customer
   */

  static fetch(customer) {
    const fiscalData = (!!customer && customer.fiscal_data) ? customer.fiscal_data : null
    const fiscalAddress = (!!fiscalData && !!fiscalData.fiscal_address) ? fiscalData.fiscal_address : null
    const municipality = (!!fiscalAddress && !!fiscalAddress.municipality) ? fiscalAddress.municipality : null
    const state = (!!fiscalAddress && !!fiscalAddress.state) ? fiscalAddress.state : null
    const customerType = (!!customer && customer.customer_type) ? customer.customer_type : null
    return {
      'asentamiento': customer.asentamiento,
      'slug': customer.slug,
      'customerType': customerType ? customerType.id : null,
      'customerTypeName': customerType ? customerType.name : '',
      'name': customer.name,
      'codename': customer.codename,
      'logo': (customer.logo && assetURL(customer.logo)) || '',
      'isActive': customer.is_active,
      'id': customer.id,
      'needAgainstReceipt': customer.need_against_receipt,
      'zones': !!customer.zones && customer.zones.map(z => z.id),
      'zonesName': !!customer.zones && customer.zones.map(z => z.name),
      'address': {
        'state': !!state && state.id,
        'stateName': !!state && state.name,
        'municipality': !!municipality && municipality.id,
        'municipalityName': !!municipality && municipality.name,
        'street': fiscalAddress ? fiscalAddress.street : '',
        'noInt': fiscalAddress ? fiscalAddress.no_int : '',
        'noExt': fiscalAddress ? fiscalAddress.no_ext : '',
        'colony': fiscalAddress ? fiscalAddress.colony : '',
        'postalCode': fiscalAddress ? fiscalAddress.postal_code : ''
      },
      'fiscal': {
        'wayToPay': fiscalData ? fiscalData.way_to_pay : '',
        'paymentMethod': fiscalData ? fiscalData.payment_method : '',
        'businessName': fiscalData ? fiscalData.business_name : '',
        'rfc': fiscalData ? fiscalData.rfc : '',
        'account': fiscalData ? fiscalData.account : '',
        'clabe': fiscalData ? fiscalData.clabe : ''
      },
      'auditor': (!!customer.auditor && customer.auditor.length > 0 && customer.auditor.map(a => a)) || [],
      'auditorName': (!!customer.auditor && customer.auditor.length > 0 && customer.auditor.map(a => a.name)) || null,
      // 'client': customer.client
      'daysToPay': customer.days_to_pay || '-'
    }
  }
  /**
   * Transform customer's info to be sent.
   *
   * @param customer The customer to be sent.
   *
   * @returns {Object} The transformed customer info
   */
  static send(customer) {
    const address = { ...customer.address }
    const fiscalAddress = {
      'state': address.state,
      'municipality': address.municipality,
      'street': address.street,
      'no_int': address.noInt,
      'no_ext': address.noExt,
      'colony': address.colony,
      'postal_code': address.postalCode
    }
    const fiscal = { ...customer.fiscal }
    const fiscalData = {
      'way_to_pay': parseInt(fiscal.wayToPay),
      'payment_method': fiscal.paymentMethod,
      'business_name': fiscal.businessName,
      'rfc': fiscal.rfc,
      'account': fiscal.account,
      'clabe': fiscal.clabe
    }
    const payload = {
      'asentamiento': customer.asentamiento,
      'customer_type': customer.customerType,
      'name': customer.name,
      'codename': customer.codename,
      'logo': customer.logo,
      'zones': customer.zones,
      'fiscal_data': {
        'fiscal_address': fiscalAddress,
        ...fiscalData
      },
      // 'client': (!!customer.client && customer.client.id) || [],
      'auditor': (!!customer.auditor && customer.auditor) || []
    }
    return payload
  }
}

export default customerTransformer
